import { useState, useEffect } from 'react';
import api from '../../../api/client';

export default function ModelsPage() {
  const [models,  setModels]  = useState([]);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);
  const [form,    setForm]    = useState({ name: '', type: 'opex' });
  const [saving,  setSaving]  = useState(false);

  async function load() {
    setLoading(true);
    try {
      const { data } = await api.get('/planning/models');
      setModels(data.data?.items || []);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { load(); }, []);

  async function handleCreate(e) {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post('/planning/models', form);
      setForm({ name: '', type: 'opex' });
      await load();
    } catch (e) {
      setError(e.message);
    } finally {
      setSaving(false);
    }
  }

  async function handleDelete(id) {
    if (!confirm('Delete this model and all its versions?')) return;
    try {
      await api.delete(`/planning/models/${id}`);
      await load();
    } catch (e) {
      setError(e.message);
    }
  }

  return (
    <div data-testid="planning-models-page" data-loading={loading ? 'true' : 'false'}>
      <h2>Plan Models</h2>

      <form onSubmit={handleCreate} style={{ marginBottom: '1.5rem' }}>
        <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
          <input
            data-testid="planning-model-name-input"
            value={form.name}
            onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
            placeholder="Model name"
            required
          />
          <select
            data-testid="planning-model-type-input"
            value={form.type}
            onChange={(e) => setForm((f) => ({ ...f, type: e.target.value }))}
          >
            {['opex', 'revenue', 'workforce', 'cashflow'].map((t) => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>
          <button type="submit" data-testid="planning-model-create" disabled={saving}>
            {saving ? 'Creating…' : 'Create Model'}
          </button>
        </div>
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </form>

      {loading ? (
        <p>Loading…</p>
      ) : (
        <table data-testid="planning-model-list" style={{ width: '100%' }}>
          <thead>
            <tr><th>Name</th><th>Type</th><th>Created</th><th></th></tr>
          </thead>
          <tbody>
            {models.map((m) => (
              <tr key={m.id} data-testid={`planning-model-row-${m.id}`}>
                <td>{m.name}</td>
                <td>{m.type}</td>
                <td>{m.created_at?.slice(0, 10)}</td>
                <td>
                  <button
                    data-testid={`planning-model-delete-${m.id}`}
                    onClick={() => handleDelete(m.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
            {!models.length && <tr><td colSpan={4}>No models yet.</td></tr>}
          </tbody>
        </table>
      )}
    </div>
  );
}
